function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFamilySvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.784314%,0.784314%,0.784314%)",
      fillOpacity: 1
    },
    d: "M 8.59375 12.527344 C 7.695312 11.839844 6.570312 11.425781 5.351562 11.425781 C 2.394531 11.425781 0 13.820312 0 16.773438 L 0 20.074219 C 0 20.460938 0.3125 20.773438 0.699219 20.773438 L 6.34375 20.773438 L 6.34375 17.398438 C 6.34375 15.453125 7.21875 13.707031 8.59375 12.527344 Z M 8.59375 12.527344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.784314%,0.784314%,0.784314%)",
      fillOpacity: 1
    },
    d: "M 5.351562 10.523438 C 7.367188 10.523438 9 8.890625 9 6.875 C 9 4.859375 7.367188 3.226562 5.351562 3.226562 C 3.335938 3.226562 1.699219 4.859375 1.699219 6.875 C 1.699219 8.890625 3.335938 10.523438 5.351562 10.523438 Z M 5.351562 10.523438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.784314%,0.784314%,0.784314%)",
      fillOpacity: 1
    },
    d: "M 12.773438 12.574219 C 10.105469 12.574219 7.945312 14.734375 7.945312 17.398438 L 7.945312 20.074219 C 7.945312 20.460938 8.257812 20.773438 8.644531 20.773438 L 14.191406 20.773438 L 14.191406 17.90625 C 14.191406 16.285156 14.875 14.824219 15.960938 13.785156 C 15.109375 13.03125 13.996094 12.574219 12.773438 12.574219 Z M 12.773438 12.574219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.784314%,0.784314%,0.784314%)",
      fillOpacity: 1
    },
    d: "M 10.988281 11.230469 C 11.503906 11.5625 12.113281 11.761719 12.773438 11.761719 C 13.429688 11.761719 14.042969 11.5625 14.554688 11.230469 C 15.460938 10.644531 16.066406 9.628906 16.066406 8.46875 C 16.066406 6.648438 14.589844 5.175781 12.773438 5.175781 C 10.953125 5.175781 9.480469 6.648438 9.480469 8.46875 C 9.480469 9.628906 10.082031 10.644531 10.988281 11.230469 Z M 10.988281 11.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.784314%,0.784314%,0.784314%)",
      fillOpacity: 1
    },
    d: "M 19.894531 13.800781 C 17.628906 13.800781 15.789062 15.640625 15.789062 17.90625 L 15.789062 20.074219 C 15.789062 20.460938 16.105469 20.773438 16.492188 20.773438 L 23.300781 20.773438 C 23.6875 20.773438 24 20.460938 24 20.074219 L 24 17.90625 C 24 15.640625 22.160156 13.800781 19.894531 13.800781 Z M 19.894531 13.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.784314%,0.784314%,0.784314%)",
      fillOpacity: 1
    },
    d: "M 18.144531 12.480469 C 18.625 12.867188 19.230469 13.109375 19.894531 13.109375 C 20.5625 13.109375 21.164062 12.867188 21.648438 12.480469 C 22.28125 11.964844 22.695312 11.191406 22.695312 10.308594 C 22.695312 8.761719 21.441406 7.507812 19.894531 7.507812 C 18.347656 7.507812 17.09375 8.761719 17.09375 10.308594 C 17.09375 11.191406 17.507812 11.964844 18.144531 12.480469 Z M 18.144531 12.480469 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilySvgrepoCom);
export default __webpack_public_path__ + "static/media/family-svgrepo-com.246756fc.svg";
export { ForwardRef as ReactComponent };